"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Navigation = require("./Navigation.style");

var Navigation = function Navigation(_ref) {
  var active = _ref.active,
      links = _ref.links,
      size = _ref.size,
      type = _ref.type;
  return /*#__PURE__*/_react.default.createElement(_Navigation.Wrapper, {
    type: type,
    role: "navigation"
  }, links && links.map(function (link, key) {
    return /*#__PURE__*/_react.default.createElement(_Navigation.NavLink, {
      key: key.toString(),
      to: link.url,
      onClick: link.onClick,
      type: type
    }, /*#__PURE__*/_react.default.createElement(_Navigation.Text, {
      size: size,
      key: key.toString(),
      as: "span",
      active: active === link.url,
      type: type
    }, link.label));
  }));
};

Navigation.propTypes = {
  active: _propTypes.default.string,
  links: _propTypes.default.arrayOf(Object),
  size: _propTypes.default.string,
  type: _propTypes.default.oneOf(['primary', 'secondary', 'utility', 'utilityFooter'])
};
Navigation.defaultProps = {
  active: '',
  links: [],
  size: 'medium',
  type: 'primary'
};
var _default = Navigation;
exports.default = _default;